<template>
  <div class="index">
    <!-- 查询 -->
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box">
          <div>
            <el-form-item label="帮扶对象：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="帮扶责任人：" prop="name">
              <el-input v-model="form.helpName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="责任人电话：" prop="phone">
              <el-input v-model="form.helpPhone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 20px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 用户操作 -->
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true"  v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" @click="openBox('create')" v-if="showBtn[3].isShow" >创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('gyxjdbfzb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._l"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
      <el-button type="primary" v-if="showBtn[5].isShow" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="550" border style="width: 99.9%">
        <el-table-column  type="selection" width="40"></el-table-column>
        <!-- 渲染表头 -->
        <el-table-column
          show-overflow-tooltip
          v-for="(o,i) in baseInfo" :key="i"
          :prop="o.key" :label="o.value"
          :fixed="i>7?false:true" align="center">
        </el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="扶贫结对帮扶管理" :modal="false"
      :visible.sync="centerDialogVisible"
      @close="close" :close-on-click-modal="false"
      width="1400px" center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="户籍地址：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="户主姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="户主身份证号码：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="家庭人口数：">
                          <el-input style="width:193px;" v-model="editForm.familyCount"></el-input>
                        </el-form-item>
                        <el-form-item label="致贫原因：">
                          <el-select size="mini" v-model="editForm.poorReason" placeholder="请选择">
                            <el-option
                              v-for="o in $public.checkList2" :key="o.label"
                              :label="o.label" :value="o.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫状态：">
                          <el-select size="mini" v-model="editForm.poorStatus" placeholder="请选择">
                            <el-option
                              v-for="o in $public.tuopinzhuangtai" :key="o.label"
                              :label="o.label" :value="o.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item prop="phone" label="贫困户联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                          <el-input type="textarea" :rows="4" style="width:386px;" v-model="editForm.desc"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="帮扶单位名称：">
                          <el-input style="width:193px;" v-model="editForm.helpOrganizationName"></el-input>
                        </el-form-item>
                        <el-form-item label="单位属性：">
                          <el-select size="mini" v-model="editForm.organizationAttr" placeholder="请选择">
                            <el-option v-for="item in $public.danweijibie" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item prop="helpName" label="帮扶责任人姓名：">
                          <el-input style="width:193px;" v-model="editForm.helpName"></el-input>
                        </el-form-item>
                        <el-form-item label="帮扶开始时间：">
                          <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="editForm.helpStartTime" style="width:193px;" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="帮扶结束时间：">
                          <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="editForm.helpEndTime" style="width:193px;" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item prop="helpPhone" label="帮扶责任人电话">
                          <el-input style="width:193px;" v-model="editForm.helpPhone"></el-input>
                        </el-form-item>
                        <el-form-item prop="title" label="帮扶责任人职务">
                          <el-input style="width:193px;" v-model="editForm.title"></el-input>
                        </el-form-item>
                        <!-- <el-form-item prop="helpIdCard" label="帮扶责任人身份证">
                          <el-input style="width:193px;" v-model="editForm.helpIdCard"></el-input>
                        </el-form-item> -->
                        <el-form-item prop="helpSex" label="帮扶责任人性别">
                          <el-select size="mini" v-model="editForm.helpSex" placeholder="请选择">
                            <el-option v-for="item in $public.sex" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        width="30%"
        title="密码修改"
        center
        :close-on-click-modal="false"
        :visible.sync="innerVisible"
        append-to-body>
        <el-input v-model="pass"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible=false,pass=''">取 消</el-button>
          <el-button type="primary" @click="sure()">确 定</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
        <el-button
          type="primary"
          v-show="!isCreate"
          style="float:right;margin-right:20px"
          :disabled="!admin&&!subAdmin"
          @click="innerVisible =true">修改帮扶责任人密码</el-button>
        <el-button v-show="!isCreate" type="primary" style="float:right;margin-right:20px" @click="clickMenu('form_pkhxx',selectRow)">查看档案</el-button>
      </div>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api:'/user/helpCP',
      form:{},
      type:'29',
      centerDialogVisible:false,
      innerVisible:false,
      tableData:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'group', value: '组'},
        {key: 'name', value: '户主姓名'},
        {key: 'idCard', value: '户主身份证号码'},
        {key: 'familyCount', value: '家庭人口数'},
        {key: 'poorReason', value: '主要致贫原因'},
        {key: 'poorStatus', value: '脱贫状态'},
        {key: 'phone', value: '贫困户联系电话'},
        {key: 'desc', value: '备注'},
        {key: 'helpOrganizationName', value: '帮扶单位名称'},
        {key: 'organizationAttr', value: '单位属性'},
        {key: 'helpName', value: '帮扶责任人姓名'},
        {key: 'title', value: '帮扶责任人职务'},
        // {key: 'helpIdCard', value: '帮扶责任人身份证'},
        {key: 'helpSex', value: '帮扶责任人性别'},
        // {key: 'helpAge', value: '帮扶责任人年龄'},
        {key: 'helpPhone', value: '帮扶责任人联系电话'},
        {key: 'helpStartTime', value: '帮扶开始时间'},
        {key: 'helpEndTime', value: '帮扶结束时间'},
      ],
      pass:'',
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        helpName: [
          { required: true, message: '请输入帮扶责任人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        helpPhone: [
          { required: true, message: '请输入帮扶责任人电话', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        helpIdCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
      },
      isCreate:false,
      openedTab:[]
    }
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.helpStartTime = new Date(newForm.helpStartTime).getTime()
      newForm.helpEndTime = new Date(newForm.helpEndTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //查看采集信息
    clickMenu(componentName,data) {
      this.centerDialogVisible = false
      this.$router.push({name: 'form_pkhxx',params: {info:data}})
      this.openedTab = this.$store.state.openedTab
      // tabNum 为当前点击的列表项在openedTab中的index，若不存在则为-1
      let tabNum = this.openedTab.indexOf(componentName)
      if (tabNum === -1) {
        // 该标签当前没有打开
        // 将componentName加入到已打开标签页state.openedTab数组中
        this.$store.commit('addTab', componentName)
      } else {
        // 该标签是已经打开过的，需要激活此标签页
        this.$store.commit('changeTab', componentName)
      }
    },
    //修改密码
    changeHelpPassword() {
        this.innerVisible =true
    },
    //提交修改
    sure() {
      if (this.pass == '') {
        return this.$message.info('请输入新密码')
      } else {
        this.$api.changeHelpPass(this.selectRow[0].helpPhone,this.pass).then(res =>{
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.pass = ''
            this.innerVisible = false
          } else{
            this._status(res.data)
          }
        })
      }
    }
  },
  created() {
    this.isShowBtn("HelpCP")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
}
</script>

<style>
.index-header{overflow-x: auto;}
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.el-textarea .el-textarea__inner{resize: none;}
</style>